// extracted by mini-css-extract-plugin
export default {"container":"BN-z","modal":"CN-z","dimensions":"DN-z","brandName":"EN-z","productName":"FN-z","labelValue":"GN-z","recipientEmail":"HN-z","recommendedFit":"IN-z","hiddenField":"JN-z"};